export class ServiceAttribute {
  public attribute: string;
}
